// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");
var Core__JSON = require("@rescript/core/src/Core__JSON.res.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("./Expln_utils_common.res.js");

function pathToStr(path) {
  if (path) {
    return Belt_List.reduceReverse(path, "", (function (a, e) {
                  return a + "/" + e;
                }));
  } else {
    return "/";
  }
}

function jsonToAny(json, path) {
  var b = Core__JSON.Classify.classify(json);
  if (typeof b !== "object") {
    return {
            TAG: "JsonNull",
            _0: path
          };
  }
  switch (b.TAG) {
    case "Bool" :
        return {
                TAG: "JsonBool",
                _0: b._0,
                _1: path
              };
    case "String" :
        return {
                TAG: "JsonStr",
                _0: b._0,
                _1: path
              };
    case "Number" :
        return {
                TAG: "JsonNum",
                _0: b._0,
                _1: path
              };
    case "Object" :
        return {
                TAG: "JsonObj",
                _0: b._0,
                _1: path
              };
    case "Array" :
        return {
                TAG: "JsonArr",
                _0: b._0,
                _1: path
              };
    
  }
}

function getPath(jsonAny) {
  if (jsonAny.TAG === "JsonNull") {
    return jsonAny._0;
  } else {
    return jsonAny._1;
  }
}

function getLocation2(jsonAny, nextPathElem) {
  var path = getPath(jsonAny);
  return pathToStr({
              hd: nextPathElem,
              tl: path
            });
}

function anyToBool(jsonAny) {
  switch (jsonAny.TAG) {
    case "JsonNull" :
        return {
                TAG: "Ok",
                _0: undefined
              };
    case "JsonBool" :
        return {
                TAG: "Ok",
                _0: jsonAny._0
              };
    default:
      return {
              TAG: "Error",
              _0: "a boolean value was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToNum(jsonAny) {
  switch (jsonAny.TAG) {
    case "JsonNull" :
        return {
                TAG: "Ok",
                _0: undefined
              };
    case "JsonNum" :
        return {
                TAG: "Ok",
                _0: jsonAny._0
              };
    default:
      return {
              TAG: "Error",
              _0: "a number value was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToInt(jsonAny) {
  return Belt_Result.map(anyToNum(jsonAny), (function (numOpt) {
                return Belt_Option.map(numOpt, (function (num) {
                              return num | 0;
                            }));
              }));
}

function anyToStr(jsonAny) {
  switch (jsonAny.TAG) {
    case "JsonNull" :
        return {
                TAG: "Ok",
                _0: undefined
              };
    case "JsonStr" :
        return {
                TAG: "Ok",
                _0: jsonAny._0
              };
    default:
      return {
              TAG: "Error",
              _0: "a string value was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToArr(jsonAny, mapper) {
  switch (jsonAny.TAG) {
    case "JsonNull" :
        return {
                TAG: "Ok",
                _0: undefined
              };
    case "JsonArr" :
        var path = jsonAny._1;
        return {
                TAG: "Ok",
                _0: jsonAny._0.map(function (json, i) {
                      return mapper(jsonToAny(json, {
                                      hd: String(i),
                                      tl: path
                                    }));
                    })
              };
    default:
      return {
              TAG: "Error",
              _0: "an array was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToObj(jsonAny, mapper) {
  switch (jsonAny.TAG) {
    case "JsonNull" :
        return {
                TAG: "Ok",
                _0: undefined
              };
    case "JsonObj" :
        return {
                TAG: "Ok",
                _0: Caml_option.some(mapper(jsonAny))
              };
    default:
      return {
              TAG: "Error",
              _0: "an object was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToJson(jsonAny) {
  if (jsonAny.TAG === "JsonNull") {
    return {
            TAG: "Ok",
            _0: undefined
          };
  } else {
    return {
            TAG: "Ok",
            _0: jsonAny._0
          };
  }
}

function getByPath(obj, attrName) {
  if (obj.TAG !== "JsonObj") {
    return {
            TAG: "Error",
            _0: "an object was expected at '" + pathToStr(getPath(obj)) + "'."
          };
  }
  var json = obj._0[attrName];
  if (json !== undefined) {
    return {
            TAG: "Ok",
            _0: jsonToAny(json, {
                  hd: attrName,
                  tl: obj._1
                })
          };
  } else {
    return {
            TAG: "Ok",
            _0: undefined
          };
  }
}

function validate(val, validator) {
  if (validator === undefined) {
    return val;
  }
  var val$1 = validator(val);
  if (val$1.TAG === "Ok") {
    return val$1._0;
  } else {
    return Expln_utils_common.exn(val$1._0);
  }
}

function getDefaultOrExn($$default, errMsg) {
  if ($$default !== undefined) {
    return $$default();
  } else {
    return Expln_utils_common.exn(errMsg());
  }
}

function makeAsValOpt(anyToVal) {
  return function (jsonAny, validator, $$default) {
    var valOpt = anyToVal(jsonAny);
    if (valOpt.TAG === "Ok") {
      return validate(valOpt._0, validator);
    }
    var msg = valOpt._0;
    return getDefaultOrExn($$default, (function () {
                  return msg;
                }));
  };
}

function makeAsVal(anyToVal, descrOfExpectedValue) {
  return function (jsonAny, validator, $$default) {
    var msg = anyToVal(jsonAny);
    if (msg.TAG === "Ok") {
      var val = msg._0;
      if (val !== undefined) {
        return validate(Caml_option.valFromOption(val), validator);
      } else {
        return getDefaultOrExn($$default, (function () {
                      return descrOfExpectedValue + " was expected at '" + pathToStr(getPath(jsonAny)) + "'.";
                    }));
      }
    }
    var msg$1 = msg._0;
    return getDefaultOrExn($$default, (function () {
                  return msg$1;
                }));
  };
}

function makeValOpt(asValOpt) {
  return function (jsonAny, attrName, validator, $$default) {
    var match = getByPath(jsonAny, attrName);
    if (match.TAG !== "Ok") {
      return getDefaultOrExn($$default, (function () {
                    return "an object was expected at '" + pathToStr(getPath(jsonAny)) + "'.";
                  }));
    }
    var attrVal = match._0;
    if (attrVal !== undefined) {
      return asValOpt(attrVal, validator, $$default);
    } else {
      return validate(undefined, validator);
    }
  };
}

function makeVal(asVal, descrOfExpectedValue) {
  return function (jsonAny, attrName, validator, $$default) {
    var match = getByPath(jsonAny, attrName);
    if (match.TAG !== "Ok") {
      return getDefaultOrExn($$default, (function () {
                    return "an object was expected at '" + pathToStr(getPath(jsonAny)) + "'.";
                  }));
    }
    var attrVal = match._0;
    if (attrVal !== undefined) {
      return asVal(attrVal, validator, $$default);
    } else {
      return getDefaultOrExn($$default, (function () {
                    return descrOfExpectedValue + " was expected at '" + getLocation2(jsonAny, attrName) + "'.";
                  }));
    }
  };
}

var asBoolOpt = makeAsValOpt(anyToBool);

var asBool = makeAsVal(anyToBool, "a boolean");

var boolOpt = makeValOpt(asBoolOpt);

var bool = makeVal(asBool, "a boolean");

var asNumOpt = makeAsValOpt(anyToNum);

var asNum = makeAsVal(anyToNum, "a number");

var numOpt = makeValOpt(asNumOpt);

var num = makeVal(asNum, "a number");

var asIntOpt = makeAsValOpt(anyToInt);

var asInt = makeAsVal(anyToInt, "an integer");

var intOpt = makeValOpt(asIntOpt);

var $$int = makeVal(asInt, "an integer");

var asStrOpt = makeAsValOpt(anyToStr);

var asStr = makeAsVal(anyToStr, "a string");

var strOpt = makeValOpt(asStrOpt);

var str = makeVal(asStr, "a string");

var asJsonOpt = makeAsValOpt(anyToJson);

var asJson = makeAsVal(anyToJson, "a json");

var jsonOpt = makeValOpt(asJsonOpt);

var json = makeVal(asJson, "a json");

function asArrOpt(arr, mapper, validator, $$default) {
  var arrOpt = anyToArr(arr, mapper);
  if (arrOpt.TAG === "Ok") {
    return validate(arrOpt._0, validator);
  }
  var msg = arrOpt._0;
  return getDefaultOrExn($$default, (function () {
                return msg;
              }));
}

function asArr(arr, mapper, validator, $$default) {
  var msg = anyToArr(arr, mapper);
  if (msg.TAG === "Ok") {
    var arrVal = msg._0;
    if (arrVal !== undefined) {
      return validate(arrVal, validator);
    } else {
      return getDefaultOrExn($$default, (function () {
                    return "an array was expected at '" + pathToStr(getPath(arr)) + "'.";
                  }));
    }
  }
  var msg$1 = msg._0;
  return getDefaultOrExn($$default, (function () {
                return msg$1;
              }));
}

function arrOpt(obj, attrName, mapper, validator, $$default) {
  var match = getByPath(obj, attrName);
  if (match.TAG !== "Ok") {
    return getDefaultOrExn($$default, (function () {
                  return "an object was expected at '" + pathToStr(getPath(obj)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asArrOpt(attrVal, mapper, validator, $$default);
  } else {
    return validate(undefined, validator);
  }
}

function arr(obj, attrName, mapper, validator, $$default) {
  var match = getByPath(obj, attrName);
  if (match.TAG !== "Ok") {
    return getDefaultOrExn($$default, (function () {
                  return "an object was expected at '" + pathToStr(getPath(obj)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asArr(attrVal, mapper, validator, $$default);
  } else {
    return getDefaultOrExn($$default, (function () {
                  return "an array was expected at '" + getLocation2(obj, attrName) + "'.";
                }));
  }
}

function asObjOpt(obj, mapper, validator, $$default) {
  var objOpt = anyToObj(obj, mapper);
  if (objOpt.TAG === "Ok") {
    return validate(objOpt._0, validator);
  }
  var msg = objOpt._0;
  return getDefaultOrExn($$default, (function () {
                return msg;
              }));
}

function asObj(arr, mapper, validator, $$default) {
  var msg = anyToObj(arr, mapper);
  if (msg.TAG === "Ok") {
    var objVal = msg._0;
    if (objVal !== undefined) {
      return validate(Caml_option.valFromOption(objVal), validator);
    } else {
      return getDefaultOrExn($$default, (function () {
                    return "an object was expected at '" + pathToStr(getPath(arr)) + "'.";
                  }));
    }
  }
  var msg$1 = msg._0;
  return getDefaultOrExn($$default, (function () {
                return msg$1;
              }));
}

function objOpt(obj, attrName, mapper, validator, $$default) {
  var match = getByPath(obj, attrName);
  if (match.TAG !== "Ok") {
    return getDefaultOrExn($$default, (function () {
                  return "an object was expected at '" + pathToStr(getPath(obj)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asObjOpt(attrVal, mapper, validator, $$default);
  } else {
    return validate(undefined, validator);
  }
}

function obj(obj$1, attrName, mapper, validator, $$default) {
  var match = getByPath(obj$1, attrName);
  if (match.TAG !== "Ok") {
    return getDefaultOrExn($$default, (function () {
                  return "an object was expected at '" + pathToStr(getPath(obj$1)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asObj(attrVal, mapper, validator, $$default);
  } else {
    return getDefaultOrExn($$default, (function () {
                  return "an object was expected at '" + getLocation2(obj$1, attrName) + "'.";
                }));
  }
}

function fromJson(json, mapper, validator, $$default) {
  try {
    var jsonAny = jsonToAny(json, /* [] */0);
    return {
            TAG: "Ok",
            _0: validate(mapper(jsonAny), validator)
          };
  }
  catch (raw_ex){
    var ex = Caml_js_exceptions.internalToOCamlException(raw_ex);
    if ($$default !== undefined) {
      return {
              TAG: "Ok",
              _0: $$default()
            };
    }
    var msg = Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(ex), (function (prim) {
                return prim.message;
              })), "no message was provided.");
    return {
            TAG: "Error",
            _0: "Parse error: " + msg
          };
  }
}

function parseJson(jsonStr, mapper, validator, $$default) {
  try {
    return fromJson(JSON.parse(jsonStr), mapper, validator, $$default);
  }
  catch (raw_ex){
    var ex = Caml_js_exceptions.internalToOCamlException(raw_ex);
    if ($$default !== undefined) {
      return {
              TAG: "Ok",
              _0: $$default()
            };
    }
    var msg = Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(ex), (function (prim) {
                return prim.message;
              })), "no message was provided.");
    return {
            TAG: "Error",
            _0: "Parse error: " + msg
          };
  }
}

function test_pathToStr(path) {
  return pathToStr(path);
}

exports.asBoolOpt = asBoolOpt;
exports.asBool = asBool;
exports.boolOpt = boolOpt;
exports.bool = bool;
exports.asNumOpt = asNumOpt;
exports.asNum = asNum;
exports.numOpt = numOpt;
exports.num = num;
exports.asIntOpt = asIntOpt;
exports.asInt = asInt;
exports.intOpt = intOpt;
exports.$$int = $$int;
exports.asStrOpt = asStrOpt;
exports.asStr = asStr;
exports.strOpt = strOpt;
exports.str = str;
exports.asJsonOpt = asJsonOpt;
exports.asJson = asJson;
exports.jsonOpt = jsonOpt;
exports.json = json;
exports.asArrOpt = asArrOpt;
exports.asArr = asArr;
exports.arrOpt = arrOpt;
exports.arr = arr;
exports.asObjOpt = asObjOpt;
exports.asObj = asObj;
exports.objOpt = objOpt;
exports.obj = obj;
exports.parseJson = parseJson;
exports.fromJson = fromJson;
exports.test_pathToStr = test_pathToStr;
/* asBoolOpt Not a pure module */
